import { z } from 'zod';
import { eventEmitter } from '@/lib/eventEmitter.ts';

const SyncToastValueSchema = z.object({
    direction: z.enum(['up', 'down']),
});

export const syncScrollHandler = (rawValue: object) => {
    const value = SyncToastValueSchema.parse(rawValue);

    eventEmitter.emit('scrollInDirection', {
        direction: value.direction,
    });
};
